import type { GlobalEventProperties } from "@v2/features/infra/analytics/events";

import * as React from "react";

import { createContext } from "replo-utils/react/context";

type GlobalEventPropertiesGetter = () => GlobalEventProperties;

// NOTE (Ezra, 2026-02-11, REPL-23713): Context stores a getter function (not
// a properties object) to avoid re-rendering consumers when analytics values
// change — they call the getter at event-fire time instead.
const GlobalEventPropertiesGetterContext =
  createContext<GlobalEventPropertiesGetter | null>(
    "GlobalEventPropertiesGetterContext",
    null,
  );

const fallbackGetter: GlobalEventPropertiesGetter = () => {
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return {} as GlobalEventProperties;
};

export const useGetGlobalEventProperties = (): GlobalEventPropertiesGetter => {
  return React.useContext(GlobalEventPropertiesGetterContext) ?? fallbackGetter;
};

export const GlobalEventPropertiesGetterProvider: React.FC<
  React.PropsWithChildren<{
    getGlobalEventProperties: GlobalEventPropertiesGetter;
  }>
> = ({ getGlobalEventProperties, children }) => {
  return (
    <GlobalEventPropertiesGetterContext.Provider
      value={getGlobalEventProperties}
    >
      {children}
    </GlobalEventPropertiesGetterContext.Provider>
  );
};
